export default __webpack_public_path__ + "static/media/asl-logo.d09557f9.png";